import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const availableExamSlots = createAsyncThunk('availableExamSlots', async ({ examId, durationMinutes, examDate, seatType, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `exam_slot/available_slots/${examId}`,
            params: {
                exam_id: examId,
                duration_minutes: durationMinutes,
                exam_date: examDate && moment(examDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD'),
                seat_type: seatType,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const availableExamSlotsSlice = createSlice({
    name: 'availableExamSlots',
    initialState: { data: [], slotPrices: [] },
    extraReducers: (builder) => {
        builder.addCase(availableExamSlots.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const raw = action.payload.data.data;
                state.data = Array.isArray(raw?.slots) ? raw.slots : (Array.isArray(raw) ? raw : []);
                state.slotPrices = Array.isArray(raw?.slot_prices) ? raw.slot_prices : [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
                state.slotPrices = []
            }
        });
    }
})

export default availableExamSlotsSlice.reducer;
